import React from 'react';
import T from 'prop-types';
import { format, yesterday } from '../../../../../utils/date';

const reportDate = `${format(yesterday(), 'dddd, MMMM D, YYYY')}`;

const TopChartsHeader = ({ headline, subheadline }) => (
  <div aria-label="Hero Image" className="prospect-charts-hero">
    <div aria-label="Hero Image" className="prospect-charts-hero-box container">
      <div className="prospect-charts-hero-text">
        <h1 className="prospect-charts-hero-headline">{headline}</h1>
        <h2 className="prospect-charts-hero-subheadline">{subheadline}</h2>
        <h3 className="prospect-charts-hero-subheadline">{reportDate}</h3>
      </div>
      <div className="prospect-charts-hero-img">
        <div className="prospect-charts-hero-img-box" />
        <div className="prospect-charts-hero-img-text-box">
          <h1 className="prospect-charts-hero-headline">Get free data!</h1>
          <h2 className="prospect-charts-hero-subheadline">
            See how you stack up against the market with a custom intelligence report
          </h2>
          <p className="prospect-charts-hero-free-report">
            <a href="/free-competitive-intelligence-report">
              Get started <i>⟶ </i>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
);

TopChartsHeader.propTypes = {
  headline: T.object.isRequired,
  subheadline: T.string.isRequired,
};
export default TopChartsHeader;
